export default __webpack_public_path__ + "static/media/ic-crops-permanent-pasture.fa9da0ed.svg";